<template>
  <article class="ExperienceCard">
      <a class="ExperienceCard-inner" :href="href">
          <div v-if="!isFixed" class="ExperienceCard-imgContainer">
              <image-vue :width="352" :height="198" :imgId="imgId" :alt="imgAlt" />
              <strong v-if="offer" class="ExperienceCard-offer" v-html="offer"/>
          </div>
          <div v-else class="ExperienceCard-fixedMessage">
              <strong class="ExperienceCard-fixedMessageText">
                  Fixed date<br> <em>special offer</em>
              </strong>
          </div>   
          <h3 class="ExperienceCard-title">{{ title }}</h3>
          <p class="ExperienceCard-desc" v-html="desc"></p>
          <div :class="['ExperienceCard-price', {
            [`ExperienceCard-price--has-offer`]: !!beforePrice
          }]">
              <strong><span v-if="isFixed || !!beforePrice">From </span>{{price}}</strong> <s v-if="beforePrice">{{beforePrice}}</s>
          </div>
      </a>
  </article>
</template>

<script>
import Image from '../UI/Image.vue';

export default {
  components: { 'image-vue': Image },
  props: {
    href: String,
    imgId: Number,
    imgAlt: String,
    title: String,
    desc: String,
    offer: String,
    price: String,
    beforePrice: String,
    isFixed: Boolean
  }
}
</script>